import { render, staticRenderFns } from "./coding-radio-box.vue?vue&type=template&id=f8f42216&"
import script from "./coding-radio-box.vue?vue&type=script&lang=js&"
export * from "./coding-radio-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coding-radio-box.vue"
export default component.exports